import axios from 'axios';
import api from './ApiAuthService';

export async function home($params = []): Promise<any> {
  try {
    const response = await api.get('/categories/home');
    return response.data;
  } catch (error) {
    console.error('Erro ao carregar a página', error);
    // throw new Error('Erro ao carregar a página');
  }
}

export async function get($channelId : any): Promise<any> {
  try {
    const response = await api.get('/categories/' + $channelId);
    return response.data;
  } catch (error) {
    console.error('Erro ao carregar as categorias', error);
    // throw new Error('Erro ao carregar a página');
  }
}

export async function getCategoriesForPartneship(): Promise<any> {
  try {
    const response = await api.get('/categories/partnerships');
    return response.data;
  } catch (error) {
    console.error('Erro ao carregar as categorias', error);
    // throw new Error('Erro ao carregar a página');
  }
}

export async function getCategory($categoryId : any): Promise<any> {
  try {
    const response = await api.get('/categories/' + $categoryId + '/get');
    return response.data;
  } catch (error) {
    console.error('Erro ao carregar a categoria', error);
    // throw new Error('Erro ao carregar a página');
  }
}
